import { OPERATIONS_CTA, OPERATIONS_SEO } from '@/data/operations';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { OperationsHero } from '@/components/site/operations/OperationsHero';
import { WhatWeDoWhoFor } from '@/components/site/operations/WhatWeDoWhoFor';
import { ProblemsWeSolve } from '@/components/site/operations/ProblemsWeSolve';
import { HowWeDeliver } from '@/components/site/operations/HowWeDeliver';
import { SystemsSection } from '@/components/site/operations/SystemsSection';
import { CaseStudy } from '@/components/site/operations/CaseStudy';
import { CtaBand } from '@/components/site/CtaBand';

export default function OperationsPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: OPERATIONS_SEO.title,
    description: OPERATIONS_SEO.description,
    canonical: `${origin}/services/operations`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Amden Operations',
      provider: { '@type': 'Organization', name: 'Amden Group' },
      serviceType: 'Operations consultancy and business systems',
      areaServed: ['Ireland', 'United Kingdom'],
      description: OPERATIONS_SEO.description,
      url: `${origin}/services/operations`,
    },
  });

  return (
    <>
      <OperationsHero />
      <WhatWeDoWhoFor />
      <ProblemsWeSolve />
      <HowWeDeliver />
      <SystemsSection />
      <CaseStudy />
      <CtaBand
        index={OPERATIONS_CTA.index}
        eyebrow={OPERATIONS_CTA.eyebrow}
        heading={OPERATIONS_CTA.heading}
        copy={OPERATIONS_CTA.copy}
        primaryLabel={OPERATIONS_CTA.primaryLabel}
        primaryHref={OPERATIONS_CTA.primaryHref}
        secondaryLabel={OPERATIONS_CTA.secondaryLabel}
        secondaryHref={OPERATIONS_CTA.secondaryHref}
      />
    </>
  );
}
